var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-from-right"}},[(_vm.sidebarOpen)?_c('aside',{staticClass:"sidebar"},[_c('focus-lock',[_vm._t("default")],2)],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }